/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/organizations-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/organizations-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/organizations-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-organizations-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/organizations.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-09-17T23:32:24.815Z
 * Source config: config/entities/organizations-entity-config.ts
 * Public fields: 18/18 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const OrganizationsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  name: Type.Union([Type.String(), Type.Null()]), // name field
  short_name: Type.Union([Type.String(), Type.Null()]), // short_name field
  contact_name: Type.Union([Type.String(), Type.Null()]), // contact_name field
  phone: Type.Union([Type.String(), Type.Null()]), // phone field
  website: Type.Union([Type.String(), Type.Null()]), // website field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
  non_member_surcharge: Type.Union([Type.Number(), Type.Null()]), // non_member_surcharge field
  allow_non_member_buddy_group: Type.Union([Type.Boolean(), Type.Null()]), // allow_non_member_buddy_group field
  membership_url: Type.Union([Type.String(), Type.Null()]), // membership_url field
  member_fee_enabled: Type.Boolean(), // member_fee_enabled field
  allow_applications: Type.Boolean(), // allow_applications field
  default_entry_fee_prize_portion: Type.Number(), // default_entry_fee_prize_portion field
  default_entry_fee_prize_portion_is_percentage: Type.Boolean(), // default_entry_fee_prize_portion_is_percentage field
  default_entry_fee_prize_portion_is_fee_deduction: Type.Boolean(), // default_entry_fee_prize_portion_is_fee_deduction field
});

export const CreateOrganizationsSchema = Type.Object({
  name: Type.Union([Type.String(), Type.Null()]), // name field
  short_name: Type.Union([Type.String(), Type.Null()]), // short_name field
  contact_name: Type.Union([Type.String(), Type.Null()]), // contact_name field
  phone: Type.Union([Type.String(), Type.Null()]), // phone field
  website: Type.Union([Type.String(), Type.Null()]), // website field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  non_member_surcharge: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // non_member_surcharge field
  allow_non_member_buddy_group: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])), // allow_non_member_buddy_group field
  membership_url: Type.Union([Type.String(), Type.Null()]), // membership_url field
  member_fee_enabled: Type.Optional(Type.Boolean()), // member_fee_enabled field
  allow_applications: Type.Optional(Type.Boolean()), // allow_applications field
  default_entry_fee_prize_portion: Type.Optional(Type.Number()), // default_entry_fee_prize_portion field
  default_entry_fee_prize_portion_is_percentage: Type.Optional(Type.Boolean()), // default_entry_fee_prize_portion_is_percentage field
  default_entry_fee_prize_portion_is_fee_deduction: Type.Optional(Type.Boolean()), // default_entry_fee_prize_portion_is_fee_deduction field
});

export const UpdateOrganizationsSchema = Type.Object({
  name: Type.Union([Type.String(), Type.Null()]), // name field
  short_name: Type.Union([Type.String(), Type.Null()]), // short_name field
  contact_name: Type.Union([Type.String(), Type.Null()]), // contact_name field
  phone: Type.Union([Type.String(), Type.Null()]), // phone field
  website: Type.Union([Type.String(), Type.Null()]), // website field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  non_member_surcharge: Type.Union([Type.Number(), Type.Null()]), // non_member_surcharge field
  allow_non_member_buddy_group: Type.Union([Type.Boolean(), Type.Null()]), // allow_non_member_buddy_group field
  membership_url: Type.Union([Type.String(), Type.Null()]), // membership_url field
  member_fee_enabled: Type.Boolean(), // member_fee_enabled field
  allow_applications: Type.Boolean(), // allow_applications field
  default_entry_fee_prize_portion: Type.Number(), // default_entry_fee_prize_portion field
  default_entry_fee_prize_portion_is_percentage: Type.Boolean(), // default_entry_fee_prize_portion_is_percentage field
  default_entry_fee_prize_portion_is_fee_deduction: Type.Boolean(), // default_entry_fee_prize_portion_is_fee_deduction field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type OrganizationsRow = Static<typeof OrganizationsSchema>;
export type OrganizationsInsert = Static<typeof CreateOrganizationsSchema>;
export type OrganizationsUpdate = Static<typeof UpdateOrganizationsSchema>;

// Legacy type aliases for backward compatibility
export type Organizations = OrganizationsRow;
export type CreateOrganizations = OrganizationsInsert;
export type UpdateOrganizations = Static<typeof UpdateOrganizationsSchema>;

// Field configuration metadata
export const OrganizationsFieldConfig = {
  filterable: ['id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'member_fee_enabled', 'allow_applications', 'default_entry_fee_prize_portion', 'default_entry_fee_prize_portion_is_percentage', 'default_entry_fee_prize_portion_is_fee_deduction'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;
